import React, { Component } from "react";

import {Link} from 'react-router-dom';

import classnames from "classnames";

const btnVerMais= {
    backgroundColor: "#529a76",
    padding: "7px 12px",
    letterSpacing: "1px",
    fontWeight: 600,
    color: "#fff",
    borderRadius: "2px",
    boxShadow: "0 2px 2.7px 0.1px rgba(0, 0, 0, 0.24)"
  
}

const textStyle = {
  
    margin: "0px",
    fontSize: "14px"
  
}

class Botao extends Component {

  componentDidMount(){
    
  }

  render() {
    return (
      
      <Link 
        to="/" 
        style={btnVerMais}
        className={classnames(
          "btn",
          "btn-ver-mais",
          this.props.isPositionAbsolute ? "btn-position-absolute" : ""
        )}
        >
        <div className="row">
          <div className="col-4">
            <i className="fas fa-glasses" />
          </div>
          <div className="col-8">
            <p style={textStyle} >Ver Mais</p>
          </div>
        </div>
      </Link>
    );
  }
}

export default Botao;
